/**
 * Initially, carrier marketplace carriers were designed to have custom code for each carrier.
 * Custom keys component, custom back-end code, and custom front-end code.
 * But in reality all of them will follow a pattern, and initially the marketplace code (.cs and .js)
 * weren't designed to be extensible.
 * Use this list to identify the carriers that have custom keys component.
 */
export const CARRIER_CODES_WITH_CUSTOM_KEYS_COMPONENT = [
    "Sherpa",
    "Doordash",
    "GoPeople",
    "Gophr",
    "Lalamove",
    "Sendle",
    "Tge",
    "Tnt",
    "Transportify",
    "Zoom2u"
]
